export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no"},{"charset":"utf-8"}],"link":[],"style":[],"script":[{"children":"if (globalThis === undefined) { var globalThis = window; }"}],"noscript":[],"charset":"utf-8","viewport":"width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const remoteComponentIslands = false

export const devPagesDir = null

export const devRootDir = null

export const vueAppRootContainer = '#__nuxt'